export const getCountries = (state) => state.onboardingState.countries;
export const getCities = (state) => state.onboardingState.cities;

export const getToken = (state) => state.onboardingState.token;

export const successRegister = (state) => state.onboardingState.openImageDialog;

export const emailExist = (state) => state.onboardingState.emailExist;
